import { render, staticRenderFns } from "./Tinymce.vue?vue&type=template&id=c027658a&"
import script from "./Tinymce.ts?vue&type=script&lang=ts&"
export * from "./Tinymce.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports